import { LocationPinIcon, MyEventIcon } from "../assets/CustomIcon";
import { config } from "../config";

// API Base URL
export const API_BASE_URL = `${config.apiBaseUrl}`;

// Media Base URL
export const MEDIA_BASE_URL = `${config.uploadUrl}`;

// Razorpay related constants
export const RAZORPAY_KEY_ID = `${config.razorpayKeyId}`;

// Event related constants
// Dropdown options for Event Categories
export const EVENT_CATEGORIES = [
    { value: "1", label: "Music" },
    { value: "2", label: "Tech" },
];

// Dropdown options for Event Sub-categories
export const EVENT_SUB_CATEGORIES = [
    { value: "1", label: "Conference" },
    { value: "2", label: "Meetup" },
];

// Dropdown options for Event Venues
export const EVENT_VENUES = [
    { value: "1", label: "Venue 1" },
];

// Dropdown options for Event Types (Online/Offline)
export const EVENT_TYPES = [
    { value: "1", label: "Free" },
    { value: "2", label: "Standard" },
    { value: "3", label: "Premium" }
];

// Dropdown options for Promotion Tags
export const PROMOTION_TAGS = [
    { value: "1", label: "Fast Selling", color: "red" },
    { value: "2", label: "Limited Seats", color: "pink" },
    { value: "3", label: "Early Bird Discount", color: "green" },
    { value: "4", label: "Registration Closing Soon", color: "blue" },
];

// Dropdown options for Contact Lists
export const CONTACT_LISTS = [
    { value: "1", label: "Contact List 1" },
    { value: "2", label: "Contact List 2" },
];

// Auth related constants
export const VALIDATION_MESSAGES = {
    EMAIL_INVALID: "Please enter a valid email address.",
    EMAIL_REQUIRED: "Please enter your email.",
    PASSWORD_REQUIRED: "Password is required.",
    NAME_REQUIRED: "Full Name is required.",
    PASSWORD_WEAK: "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.",
    PASSWORDS_DO_NOT_MATCH: "Passwords do not match.",
    IDENTIFIER_REQUIRED: "Please enter your email or phone number.",
    IDENTIFIER_INVALID: "Please enter a valid email address or 10-digit phone number.",
    PHONE_INVALID: "Please enter a valid 10-digit phone number.",
    PHONE_REQUIRED: "Phone number is required.",
    IDENTIFIER_EXISTS: "Email or phone number already exists.",
    VENUE_NAME_REQUIRED: "Venue Name is required.",
    VENUE_DESCRIPTION_REQUIRED: "Venue Description is required.",
    VENUE_IMAGES_REQUIRED: "Please select at least one image.",
    ADDRESS_LINE1_REQUIRED: "Address Line 1 is required.",
    COUNTRY_REQUIRED: "Country is required.",
    CITY_REQUIRED: "City is required.",
    STATE_REQUIRED: "State is required.",
    PINCODE_REQUIRED: "Pincode is required.",
    VENUE_CATEGORY_REQUIRED: "Venue Category is required.",
    VENUE_SUB_CATEGORY_REQUIRED: "Venue Sub Category is required.",
    LISTING_PROMO_DATE_REQUIRED: "Listing Promo Date & Time is required.",
    LISTING_EXPIRY_DATE_REQUIRED: "Listing Expiry Date & Time is required.",
    SEATING_CATEGORY_REQUIRED: "Seating / Tickets Category is required.",
    SEATS_NO_REQUIRED: "Number of Seats / Tickets is required.",
    EVENT_NAME_REQUIRED: "Event Name is required.",
    EVENT_DESCRIPTION_REQUIRED: "Event Description is required.",
    EVENT_START_DATE_REQUIRED: "Event Start Date & Time is required.",
    EVENT_END_DATE_REQUIRED: "Event End Date & Time is required.",
    EVENT_CATEGORY_REQUIRED: "Event Category is required.",
    EVENT_SUB_CATEGORY_REQUIRED: "Event Sub Category is required.",
    EVENT_VENUE_REQUIRED: "Please select a venue.",
    EVENT_TYPE_REQUIRED: "Event Type is required.",
    EVENT_NAME_REQUIRED_1: "Please enter event name",
    EVENT_DESC_REQUIRED: "Please enter event description",
    START_DATE_REQUIRED: "Please select start date & time",
    END_DATE_REQUIRED: "Please select end date & time",
    EVENT_IMAGE_REQUIRED: "Please upload at least one event image",
    CURRENCY_REQUIRED: "Currency is required.",
    PRICE_REQUIRED: "Price is required.",
    VENUE_REQUIRED: "Please select venue",
    EVENT_BANNER_IMAGE_REQUIRED: "Please upload at least one banner image",
    CONTACT_TYPE_REQUIRED: "Contact Type is required.",

    // Login error messages
    LOGIN_INCORRECT_PASSWORD: "Incorrect email or password.",
    LOGIN_FAILED: "Login failed. Please check your credentials.",
    LOGIN_USER_NOT_FOUND: "User not found. Please check your email/phone.",

    // OTP error messages
    OTP_WRONG: "Wrong OTP entered. Please try again.",
    OTP_INCOMPLETE: "Please enter all 4 digits.",
    OTP_EXPIRED: "OTP has expired. Please request a new one."
};

// Stats data for the dashboard page
export const STATS_DATA = [
    {
        title: "Listed Events",
        icon: <MyEventIcon />,
        colorClass: "pink",
        id: "events"
    },
    {
        title: "Listed Venues",
        icon: <LocationPinIcon />,
        colorClass: "blue",
        id: "venues"
    },
    {
        title: "Contacts",
        icon: <LocationPinIcon />,
        colorClass: "blue",
        id: "contacts"
    },
    {
        title: "Tickets",
        icon: <LocationPinIcon />,
        colorClass: "blue",
        id: "tickets"
    }
];

// Placeholder banner slides for the home page
export const BANNER_SLIDES = [
    {
        src: "https://pingvite-media-prod.s3.ap-south-1.amazonaws.com/uploads/event/banner/1d6e414b-fbb0-47a9-9e2b-6fbab12c6019.jpg",
        alt: "AI Technology pitch night",
    },
    {
        src: "https://pingvite-media-prod.s3.ap-south-1.amazonaws.com/uploads/event/banner/c00f427a-67da-446a-8e75-2a2c8716e7fa.png",
        alt: "Indus tech",
    },
    {
        src: "https://pingvite-media-prod.s3.ap-south-1.amazonaws.com/uploads/event/banner/c32eee3f-e6bd-4e78-bd96-b682107c6437.png",
        alt: "Pack printex",
    }
];

// Contact type constants
export const CONTACT_TYPE_MAP = {
    Family: 1,
    Friend: 2,
    Work: 3,
};

// Contact type labels
export const CONTACT_TYPE_LABELS = {
    1: "Family",
    2: "Friend",
    3: "Work",
};

// Contact type colors
export const CONTACT_TYPE_COLORS = {
    1: "purple",
    2: "green",
    3: "blue",
};
